import apiClient from './apiClient'
import { ENDPOINTS } from './endpoints'

export interface KpiMetric {
  title?: string
  value?: string | number
  change?: string | number
  trend?: 'up' | 'down' | 'neutral' | string
  subtext?: string
  total?: number
  active?: number
  inactive?: number
  [key: string]: any
}

/**
 * 1. GET /api/dashboard/admin
 * Centralized Admin Dashboard Aggregator
 */
export const fetchAdminDashboardAggregator = async (): Promise<any> => {
  const { data } = await apiClient.get(ENDPOINTS.DASHBOARD.ADMIN)
  return data?.data ?? data
}

/**
 * 2. GET /api/dashboard/student
 * Centralized Student Dashboard Aggregator
 */
export const fetchStudentDashboardAggregator = async (): Promise<any> => {
  const { data } = await apiClient.get(ENDPOINTS.DASHBOARD.STUDENT)
  return data?.data ?? data
}

/**
 * 3. GET /api/dashboard/staff
 * Centralized Staff Dashboard Aggregator
 */
export const fetchStaffDashboardAggregator = async (): Promise<any> => {
  const { data } = await apiClient.get(ENDPOINTS.DASHBOARD.STAFF)
  return data?.data ?? data
}

/**
 * 4. GET /api/dashboard/kpis
 * Centralized Multi-Domain Dashboard KPI Metrics
 */
export const fetchCentralizedKpis = async (): Promise<any> => {
  const { data } = await apiClient.get(ENDPOINTS.DASHBOARD.KPIS)
  return data?.data ?? data
}

/**
 * 5. GET /api/dashboard/kpis/student
 * Student Domain KPI Metrics
 */
export const fetchStudentKpis = async (): Promise<any> => {
  const { data } = await apiClient.get(ENDPOINTS.DASHBOARD.KPIS_STUDENT)
  return data?.data ?? data
}

/**
 * 6. GET /api/dashboard/kpis/staff
 * Staff Management KPI Metrics
 */
export const fetchStaffKpis = async (): Promise<any> => {
  const { data } = await apiClient.get(ENDPOINTS.DASHBOARD.KPIS_STAFF)
  return data?.data ?? data
}

/**
 * 7. GET /api/dashboard/kpis/seat
 * Seat Management KPI Metrics
 */
export const fetchSeatKpis = async (): Promise<any> => {
  const { data } = await apiClient.get(ENDPOINTS.DASHBOARD.KPIS_SEAT)
  return data?.data ?? data
}

/**
 * 8. GET /api/dashboard/kpis/academic
 * Academic Domain KPI Metrics
 */
export const fetchAcademicKpis = async (): Promise<any> => {
  const { data } = await apiClient.get(ENDPOINTS.DASHBOARD.KPIS_ACADEMIC)
  return data?.data ?? data
}

/**
 * 9. GET /api/dashboard/kpis/subject
 * Subject Management KPI Metrics
 */
export const fetchSubjectKpis = async (): Promise<any> => {
  const { data } = await apiClient.get(ENDPOINTS.DASHBOARD.KPIS_SUBJECT)
  return data?.data ?? data
}

/**
 * 10. GET /api/dashboard/kpis/user
 * User Management KPI Metrics
 */
export const fetchUserKpis = async (): Promise<any> => {
  const { data } = await apiClient.get(ENDPOINTS.DASHBOARD.KPIS_USER)
  return data?.data ?? data
}

/**
 * 11. GET /api/dashboard/kpis/role
 * Role Management KPI Metrics
 */
export const fetchRoleKpis = async (): Promise<any> => {
  const { data } = await apiClient.get(ENDPOINTS.DASHBOARD.KPIS_ROLE)
  return data?.data ?? data
}

/**
 * 12. GET /api/dashboard/kpis/department
 * Department Management KPI Metrics
 */
export const fetchDepartmentKpis = async (): Promise<any> => {
  const { data } = await apiClient.get(ENDPOINTS.DASHBOARD.KPIS_DEPARTMENT)
  return data?.data ?? data
}

/**
 * 13. GET /api/dashboard/kpis/designation
 * Designation Management KPI Metrics
 */
export const fetchDesignationKpis = async (): Promise<any> => {
  const { data } = await apiClient.get(ENDPOINTS.DASHBOARD.KPIS_DESIGNATION)
  return data?.data ?? data
}

/**
 * 14. GET /api/communications/dashboard
 * Communication Module Dashboard KPI Metrics
 */
export const fetchCommunicationKpis = async (): Promise<any> => {
  const { data } = await apiClient.get(ENDPOINTS.COMMUNICATION.DASHBOARD)
  return data?.data ?? data
}

export const dashboardKpisApi = {
  fetchAdminDashboardAggregator,
  fetchStudentDashboardAggregator,
  fetchStaffDashboardAggregator,
  fetchCentralizedKpis,
  fetchStudentKpis,
  fetchStaffKpis,
  fetchSeatKpis,
  fetchAcademicKpis,
  fetchSubjectKpis,
  fetchUserKpis,
  fetchRoleKpis,
  fetchDepartmentKpis,
  fetchDesignationKpis,
  fetchCommunicationKpis,
}

export default dashboardKpisApi
